import { ITheme, THEME_TYPE } from 'interfaces';
import { DefaultTheme } from 'styled-components';

export const baseTheme: ITheme = {
	colors: {
		primary: '#6d25a8',
		primaryGradient1: 'linear-gradient(225deg, #542285 0%, #226 100%)',
		primaryGradient2: 'linear-gradient(225deg, #{rgba(#542285, 0.5)} 0%, #{rgba(#226, 0.5)} 100%)',
		primaryGradient3:
			'linear-gradient(225deg, #{rgba(#7652b2, 0.93)} 0%, #{rgba(#605c98, 0.93)} 100%)',
		primaryGradient4: 'linear-gradient(225deg, #7652b2 0%, #605c98 100%)',
		primaryGradient5:
			'linear-gradient(225deg, rgba(84, 34, 133, 0.5) 0%, rgba(34, 34, 102, 0.5) 100%)',
		primaryGradient6: 'linear-gradient(267deg, #ff00d2 -58.07%, #9921b6 33.11%, #2a519e 105.03%)',
		primaryGradient7:
			'linear-gradient(225deg,color(display-p3 0.5388 0.2911 0.7886) 0%,color(display-p3 0.3027 0.2739 0.6944) 100%)',
		primaryGradient8: 'linear-gradient(225deg, rgb(84, 34, 133) 0%, rgb(34, 34, 102) 100%)',
		primaryGradient9:
			'linear-gradient(246deg, rgba(208, 37, 255, 0.16) 0%, rgba(49, 59, 246, 0.16) 44.09%, rgba(0, 174, 255, 0.16) 103.55%)',
		primaryGradient10:
			'linear-gradient(246deg, rgba(208, 37, 255, 0.9) 0%, rgba(49, 59, 246, 0.9) 44.09%, rgba(0, 174, 255, 0.9) 103.55%)',

		text1: '#000',
		text2: 'rgba(0, 0, 0, 0.2)',
		text3: '#fff',
		text4: '#c2c2c2',
		text5: '#1a1a1a',
		text6: '#6d25a8',
		text7: '#6a48bd',
		text8: '#bcbcbc',
		text9: '#7b7991',
		text10: 'rgba(0, 0, 0, 0.46);',
		text11: '#030303',
		text12: '#949494',
		text13: '#6d25a8',
		text14: '#8211b5',
		text15: '#3e65ef',
		text16: '#3e65ef',
		text17: '#6d25a8',
		text18: 'rgba(51, 51, 51, 0.5)',
		text19: '#ffffff66',
		text20: 'rgba(96, 103, 112, .7)',
		text21: '#333',
		text22: '#3e65ef',
		text23: '#FF075A',
		text24: '#f04',
		text25: '#00d100',
		text26: '#771eae',
		text27: '#808080',

		bg1: '#fff',
		bg2: '#f3f2f9',
		bg3: '#e8e6f5',
		bg4: '#d9d9d9',
		bg5: 'rgb(222, 222, 224)',
		bg6: '#fff',
		bg7: '#f4f3fb',
		bg8: '#ffffff',
		bg9: '#f2f2f9',
		bg10: '#f6f8fa',
		bg11: 'rgba(214, 210, 234, 0.30)',
		bg12: '#f3f2fa',
		bg13: 'linear-gradient(225deg, #f8f7fd 0%, #ecebf6 100%)',
		bg14: 'rgba(0, 209, 0, 0.08)',
		bg15: '#f6f8fa',
		border: 'rgba(222, 222, 224)',
		border2: '#949494',
		borderActive: '#9c9c9c',
	},

	media: {
		xl: '(max-width: 1140px)',
		lg: '(max-width: 960px)',
		md: '(max-width: 720px)',
		sm: '(max-width: 540px)',
	},

	borderRadius: {
		xs: '2.5px',
		sm: '5px',
		md: '10px',
	},

	durations: {
		ms300: 300,
		ms200: 200,
	},

	containerWidth: '465px',
	contentWidth: '430px',
	headerHeight: '60px',
	continiueButtonHeight: '80px',

	space: {
		xl: '20px',
		lg: '16px',
		md: '12px',
		sm: '8px',
		xs: '4px',
	},

	fontWeight: {
		extralight: 100,
		light: 200,
		demi: 300,
		regular: 400,
		medium: 500,
		demibold: 600,
		bold: 700,
		extrabold: 800,
		black: 900,
	},
};

export const lightTheme: DefaultTheme = {
	...baseTheme,
	type: THEME_TYPE.LIGHT,

	colors: {
		...baseTheme.colors,
		primary: '#6d25a8',
		primaryGradient1: 'linear-gradient(225deg, #542285 0%, #226 100%)',
		primaryGradient2: 'linear-gradient(225deg, #{rgba(#542285, 0.5)} 0%, #{rgba(#226, 0.5)} 100%)',
		primaryGradient3:
			'linear-gradient(225deg, #{rgba(#7652b2, 0.93)} 0%, #{rgba(#605c98, 0.93)} 100%)',
		primaryGradient4: 'linear-gradient(225deg, #7652b2 0%, #605c98 100%)',
		primaryGradient6: 'linear-gradient(267deg, #ff00d2 -58.07%, #9921b6 33.11%, #2a519e 105.03%)',
		primaryGradient7:
			'linear-gradient(225deg,color(display-p3 0.5388 0.2911 0.7886) 0%,color(display-p3 0.3027 0.2739 0.6944) 100%)',
		primaryGradient8: 'linear-gradient(225deg, rgb(84, 34, 133) 0%, rgb(34, 34, 102) 100%)',
		primaryGradient9:
			'linear-gradient(246deg, rgba(208, 37, 255, 0.16) 0%, rgba(49, 59, 246, 0.16) 44.09%, rgba(0, 174, 255, 0.16) 103.55%)',
		primaryGradient10:
			'linear-gradient(246deg, rgba(208, 37, 255, 0.9) 0%, rgba(49, 59, 246, 0.9) 44.09%, rgba(0, 174, 255, 0.9) 103.55%)',

		text1: '#000',
		text2: 'rgba(0, 0, 0, 0.2)',
		text3: '#fff',
		text4: '#c2c2c2',
		text5: '#1a1a1a',
		text6: '#6d25a8',
		text7: '#6a48bd',
		text8: '#bcbcbc',
		text9: '#7b7991',
		text10: 'rgba(0, 0, 0, 0.46);',
		text11: '#030303',
		text12: '#949494',
		text13: '#6d25a8',
		text14: '#8211b5',
		text15: '#3e65ef',
		text16: '#3e65ef',
		text17: '#6d25a8',
		text18: 'rgba(51, 51, 51, 0.5)',
		text19: '#ffffff66',
		text20: 'rgba(96, 103, 112, .7)',
		text21: '#333',
		text22: '#3e65ef',
		text23: '#FF075A',
		text25: '#00D100',
		text24: '#f04',
		text26: '#771eae',
		text27: '#808080',

		bg1: '#fff',
		bg2: '#f3f2f9',
		bg3: '#e8e6f5',
		bg4: '#d9d9d9',
		bg5: 'rgb(222, 222, 224)',
		bg6: '#fff',
		bg7: '#f4f3fb',
		bg8: '#ffffff',
		bg9: '#f2f2f9',
		bg10: '#f6f8fa',
		bg11: 'rgba(214, 210, 234, 0.30)',
		bg12: '#f3f2fa',
		bg13: 'linear-gradient(225deg, #f8f7fd 0%, #ecebf6 100%)',
		bg14: 'rgba(0, 209, 0, 0.08)',
		bg15: '#f6f8fa',
		border: 'rgba(222, 222, 224)',
		border2: '#949494',
		borderActive: '#9c9c9c',
	},
};

export const darkTheme: DefaultTheme = {
	...baseTheme,
	type: THEME_TYPE.DARK,

	colors: {
		...baseTheme.colors,
		primary: '#9580f7',
		primaryGradient1: 'linear-gradient(225deg, #542285 0%, #226 100%)',
		primaryGradient2: 'linear-gradient(225deg, #542285 0%, #226 100%)',
		primaryGradient3:
			'linear-gradient(225deg, #{rgba(#7652b2, 0.93)} 0%, #{rgba(#605c98, 0.93)} 100%)',
		primaryGradient4: 'linear-gradient(225deg, #7652b2 0%, #605c98 100%)',
		primaryGradient6:
			'linear-gradient(254deg, #FF883E 0%, #FF21DE 66.91%, #3092FF 146.5%, #3795FF 152.22%);',
		primaryGradient7: '#9580F7',
		primaryGradient8: '#9580F7',
		primaryGradient9:
			'linear-gradient(246deg, rgba(208, 37, 255, 0.60)0%, rgba(49, 59, 246, 0.60)44.09%, rgba(0, 174, 255, 0.60)103.55%)',
		primaryGradient10:
			'linear-gradient(232deg, rgba(190, 0, 255, 0.90)-136.75%, rgba(72, 82, 255, 0.90)-33.94%, rgba(0, 198, 255, 0.90)104.68%)',

		text1: '#fff',
		text2: 'rgba(225, 225, 225, 0.2)',
		text3: '#000',
		text4: '#918fa8',
		text5: '#ffffff',
		text6: '#9580f7',
		text7: '#9580F7',
		text8: '#ffffff',
		text9: '#9D9DA0',
		text10: 'rgba(255, 255, 255, 0.46)',
		text11: '#fff',
		text12: 'rgba(222,222,224,0.3)',
		text13: '#9A7FFF',
		text14: '#9A7FFF',
		text15: '#5d80ff',
		text16: '#fff',
		text17: 'rgb(130, 17, 181)',
		text18: '#ffffff99',
		text19: '#ffffffb3',
		text20: '#ffffff99',
		text21: '#9ea2af',
		text22: '#ffffff',
		text23: '#FF075A',
		text25: '#00EF00',
		text24: '#FF0E4E',
		text26: '#9580F7',
		text27: 'rgba(255, 255, 255, 0.60)',

		bg1: '#000',
		bg2: '#373640',
		bg3: '#474655',
		bg4: '#d9d9d9',
		bg5: '#373640',
		bg6: '#1E1E1E',
		bg7: '#292929',
		bg8: '#2b2f3c',
		bg9: 'rgb(55, 54, 64)',
		bg10: '#1d2027',
		bg11: 'rgba(255, 255, 255, 0.08)',
		bg12: 'rgba(239, 254, 255, 0.12)',
		bg13: 'linear-gradient(225deg, #262526 0%, #19181A 100%)',
		bg14: 'rgba(0, 239, 0, 0.08)',
		bg15: '#373640',
		border: 'rgba(222, 222, 224, 0.3)',
		border2: '#dedee04d',
		borderActive: '#9c9c9c',
	},
};
